export default "__VITE_ASSET__C5yBEXCw__"